module.exports = __webpack_public_path__ + "fonts/MyriadPro-CondIt.bd1c1180.otf";